import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOtherSteps = (props) => /* @__PURE__ */ _jsx("svg", {
	name: "other-steps",
	viewBox: "0 0 336 336",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(106.182)",
				children: [/* @__PURE__ */ _jsx("path", {
					className: "shadow",
					d: "M4 24H64.728a8 8 0 0 1 6.4 3.2l18.908 25.212a8 8 0 0 1 1.6 4.8V142.181a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V28a4 4 0 0 1 4-4z",
					fillOpacity: .16,
					fill: "#000"
				}), /* @__PURE__ */ _jsxs("g", {
					className: "main",
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M20 0H80.728a8 8 0 0 1 6.4 3.2l18.908 25.212a8 8 0 0 1 1.6 4.8V118.181a4 4 0 0 1-4 4H20a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
						fill: "#FFF"
					}), /* @__PURE__ */ _jsx("rect", {
						fill: "#1FB790",
						x: 28.218,
						y: 97.745,
						width: 36.655,
						height: 12.218,
						rx: 2
					})]
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(122.182 152.727)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M4 0H64.728a8 8 0 0 1 6.4 3.2l18.908 25.212a8 8 0 0 1 1.6 4.8V118.181a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
					fill: "#FFF",
					opacity: .4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#1FB790",
					x: 12.218,
					y: 97.745,
					width: 36.655,
					height: 12.218,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(0 61.09)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M4 0H64.728a8 8 0 0 1 6.4 3.2l18.908 25.212a8 8 0 0 1 1.6 4.8V118.181a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
					fill: "#FFF",
					opacity: .4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#FFC900",
					x: 12.218,
					y: 97.745,
					width: 36.655,
					height: 12.218,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(0 213.818)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M4 0H64.728a8 8 0 0 1 6.4 3.2l18.908 25.212a8 8 0 0 1 1.6 4.8V118.181a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
					fill: "#FFF",
					opacity: .4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#1FB790",
					x: 12.218,
					y: 97.745,
					width: 36.655,
					height: 12.218,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(244.364 213.818)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M4 0H64.728a8 8 0 0 1 6.4 3.2l18.908 25.212a8 8 0 0 1 1.6 4.8V118.181a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
					fill: "#FFF",
					opacity: .4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#1FB790",
					x: 12.218,
					y: 97.745,
					width: 36.655,
					height: 12.218,
					rx: 2
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(244.364 61.09)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M4 0H64.728a8 8 0 0 1 6.4 3.2l18.908 25.212a8 8 0 0 1 1.6 4.8V118.181a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
					fill: "#FFF",
					opacity: .4
				}), /* @__PURE__ */ _jsx("rect", {
					fill: "#FFC900",
					x: 12.218,
					y: 97.745,
					width: 36.655,
					height: 12.218,
					rx: 2
				})]
			})
		]
	})
});
export default SvgOtherSteps;
